/**
 * SMS tab Placement Recruiter filter — replicates My Candidates - Retention filter control.
 * Uses CustomFilter + TYPEAHEADDROPDOWN, same as CandidatesFilter.
 */
import { CustomFilter } from 'app/ComponentLibrary/Filter';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectUser } from 'oidc/user.selectors';
import { Concatenate } from 'utils/string/string';
import { getSmsRecruiterFilterSpecs, defaultSmsFilterValues, HIDE_RECRUITER_FILTER_FOR_SMS } from './DashboardRetentionFilterUtils';

export const defaultSmsRecruiterFilterValues = defaultSmsFilterValues;

export interface DashboardSmsRecruiterFilterProps {
  recruiterOptions: { id: number; name: string; value: number }[];
  onApplyFilter: (values: Record<string, unknown>) => void;
  onAfterReset?: () => void;
  /** Hide Placement Recruiter; show only Phone number. Default from HIDE_RECRUITER_FILTER_FOR_SMS. */
  hideRecruiterFilter?: boolean;
}

export const DashboardSmsRecruiterFilter: React.FC<DashboardSmsRecruiterFilterProps> = ({
  recruiterOptions,
  onApplyFilter,
  onAfterReset,
  hideRecruiterFilter = HIDE_RECRUITER_FILTER_FOR_SMS,
}) => {
  const { setValue } = useFormContext();
  const { userInfo } = useSelector(selectUser) ?? {};
  const fields = useMemo(
    () => getSmsRecruiterFilterSpecs(recruiterOptions, { hideRecruiterFilter }),
    [recruiterOptions, hideRecruiterFilter],
  );

  const resetFilter = () => {
    setValue('senderPhoneNumber', '');
    if (userInfo?.employeeId) {
      const placementRecruiter = {
        id: userInfo.employeeId,
        name: Concatenate([userInfo.firstName ?? '', userInfo.lastName ?? ''], ' ').trim() || `User ${userInfo.employeeId}`,
        value: userInfo.employeeId,
      };
      setValue('placementRecruiter', placementRecruiter);
      onApplyFilter({ placementRecruiter, senderPhoneNumber: '' });
    } else {
      setValue('placementRecruiter', null);
      onApplyFilter({ placementRecruiter: null, senderPhoneNumber: '' });
    }
    onAfterReset?.();
  };

  return (
    <CustomFilter
      fields={fields}
      onResetForm={resetFilter}
      justifyContent="flex-start"
      version2
      analytics={{ caller: 'TaskOperations', onApply: true, properties: { category: 'Dashboard-SMS' } }}
    />
  );
};
